module.controller('activateCardCtrl', ['$scope', '$state', '$http', '$window', 'cacheService', 'Transform', 'baseURI', 'OVERLAY', '$rootScope', function ($scope, $state, $http, $window, cacheService, Transform, baseURI, OVERLAY, $rootScope){
    var activateUrl = baseURI + 'card/activate';

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to activate your card at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.overlay = OVERLAY['member.home.profile/activate'];
    $scope.formData = {};

    // activate year ranges
    var currentYear = new Date().getFullYear();
    $scope.minYear = currentYear - 1;
    $scope.maxYear = currentYear + 10;

    // Footer btns
    $scope.mainBtn = {
      attemptSubmission: true,
      title: 'ACTIVATE'
    };
    $scope.cancel = true;

    $scope.range = function (min, max, reverse){
      var options = [];
      for(var i = min; i <= max; i++){
        options.push(i);
      }
      return (reverse ? options.reverse() : options);
    };

    $scope.attemptSubmission = function (formData){
      if(formData.$valid){
        activateCard();
        $scope.alert.errorShown = false;
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };

    var activateCard = function(){
      var month = ($scope.formData.CardMonth < 10 ? ('0' + $scope.formData.CardMonth) : $scope.formData.CardMonth);
      $scope.formData.ExpDate = month + '/' +
      $scope.formData.CardYear;
      $scope.formData._key = $scope.brand.api_key;
      $scope.loading = true;

      $http({
        method: 'POST',
        url: activateUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode($scope.formData)
      }).then(function (resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          cacheService.clear('subcard');
          $scope.mainBtn = false;
          $scope.cancel = false;
          $scope.close = true;
          $scope.alert.successMessage = 'You have activated your card.';
          $scope.alert.successShown = true;
        } else {
          $scope.invalidRequest = true;
        }
      }).catch(function (error){
        $scope.loading = false;
        $scope.alert.alertShown = true;
      });
    };

  }]);
